export default __webpack_public_path__ + "static/media/Pedro_1.40afad3d.webp";